import { FULL_ACCESS, InternalAdminRole } from 'constants/internal-admin-roles';
import Enterprise from 'types/models/enterprise';
import User from 'types/models/user';

/**
 * Checks if the user has territory access to an enterprise.
 *
 * @param user The user whose territory access is being checked
 * @param enterprise The enterprise to check against
 * @returns true if the user has access to the enterprise's territory
 */
export const userHasTerritoryAccessToEnterprise = (
  user: User | null,
  enterprise: Enterprise
): boolean => {
  if (!user || user.adminRole === InternalAdminRole._NONE) {
    return false; // No access
  }

  if (user.adminRole === InternalAdminRole.SALES_ADMIN) {
    const territoryAccess = user.internalAccessPolicy?.territories;
    if (!territoryAccess) return false;
    if (territoryAccess === FULL_ACCESS) return true;

    const enterpriseState = enterprise.billingAddress?.state;
    if (!enterpriseState) return false;

    // territoryAccess is an array of countries at this point
    const countryInAccess = territoryAccess.find(country => country.code === enterpriseState.countryAbbreviation);
    if (!countryInAccess) return false;
    if (countryInAccess.stateCodes === FULL_ACCESS) return true;

    return countryInAccess.stateCodes.includes(enterpriseState.abbreviation);
  }

  return true; // Full access
};